import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import SearchProductCard from "./SearchProductCard";
import { getApi } from "../../../../../../../../services/api/globalApi";

const SearchProduct = forwardRef(({ handleShowProduct }, ref) => {
  const [productData, setProductData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
  }));

  const getProduct = async (params) => {
    const path = "admin/products";
    try {
      const response = await getApi({ path, params: { ...params, limit: 20 } });
      setProductData(response?.data?.result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProduct({});
  }, []);

  const [filter, setFilter] = useState({});

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProduct(allFilter);
  };

  const addProduct = (data) => {
    handleShowProduct(data);
    setShowModal(false);
  };

  return (
    <>
      <div
        onClick={() => setShowModal(!showModal)}
        className={`fixed z-[65] invisible opacity-0 bottom-0 left-0 top-0 right-0 bg-black/30 backdrop-blur-sm  ${
          showModal && "!opacity-100 !visible"
        }`}
      ></div>
      <div
        className={`z-[70] shadow-[0px_0px_28px_-8px_rgba(0,0,0,0.3)] bg-white rounded-t-[40px] flex-col justify-between fixed top-[100%] left-0 bg-white w-full h-[90%] transition-all opacity-0 invisible ${
          showModal && "opacity-100 !visible !top-[10%]"
        }`}
      >
        <button
          onClick={() => setShowModal(false)}
          type="button"
          className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          data-modal-hide="popup-modal"
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">بستن مدال</span>
        </button>
        <div className="w-full px-4 my-6">
          <p>جست و جو محصول</p>

          <div class="w-full mx-auto mt-6">
            <label
              for="default-search"
              class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <svg
                  class="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                class="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="جست‌و‌جو محصول ..."
                required
                onChange={(e) =>
                  filterDataHandler({ page: 1, name: e.target.value })
                }
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full h-full overflow-y-scroll">
          {productData?.length ? (
            productData.map((item) => {
              return <SearchProductCard data={item} addProduct={addProduct} />;
            })
          ) : (
            <div className="py-10 shadow flex items-center justify-center w-11/12 mx-auto rounded-xl">
              <p>محصولی وجود ندارد</p>
            </div>
          )}
          <div className="w-full py-24"></div>
        </div>
      </div>
    </>
  );
});

export default SearchProduct;
